import PastSearches from "./PastSearches";
import PopularSearches from "./PopularSearches";
import SpecialProducts from "./SpecialProducts";
import SearchSuggestions from "./SearchSuggestions";

interface SearchDropdownContentProps {
  onClose: () => void;
  query?: string;
  onSelect?: (term: string) => void;
}

const SearchDropdownContent = ({
  onClose,
  query = "",
  onSelect = () => {},
}: SearchDropdownContentProps) => {
  if (query.length >= 2) {
    return (
      <SearchSuggestions query={query} onClose={onClose} onSelect={onSelect} />
    );
  }

  return (
    <>
      <PastSearches onClose={onClose} />
      <PopularSearches onClose={onClose} />
      <SpecialProducts onClose={onClose} />
    </>
  );
};

export default SearchDropdownContent;
